var promotionFill = "https://shopfront-cdn.tekoapis.com/static/a2125525237c799e.svg";

export { promotionFill as default };
